import { handleUtagEvent } from '@core/js/actions/initialActions.js';
import { createGAEvent } from '../utils/analyticsUtils';

export function handleSearchSubmitAnalytics(store, searchValue) {
    const gaEvent = createGAEvent(
        _.get(store.getState(), 'core.pageType'),
        'search|regular',
        searchValue
    );
    store.dispatch(handleUtagEvent(gaEvent, 'link'));
}
